import classNames from "classnames";
import React, { FC } from "react";
import styles from "./tableStyle.module.css";

type TableProps = {
  minWidth?: number;
  useRowSpacing?: boolean;
  useCellSpacing?: boolean;
  overflowScroll?: boolean;
};

const Table: FC<TableProps> = ({
  children,
  minWidth,
  useCellSpacing = true,
  useRowSpacing = true,
  overflowScroll = true,
}) => {
  // NOTE Tailwind JIT causes propbelms, using inline style instead
  return (
    <div className={classNames({ "overflow-x-auto": overflowScroll })}>
      <table
        style={{ minWidth: `${minWidth}px` }}
        className={classNames(
          "w-full",
          "h-10",
          "md:text-sm",
          useCellSpacing && styles.cellSpacing,
          useRowSpacing && styles.rowSpacing
        )}
      >
        {children}
      </table>
    </div>
  );
};

export default Table;
